import React from 'react';
import './scss/appbar.css'
import NavLink from '../../styledcomponents/NavLink/index'
import Drawer from '../Drawer/Drawer';
import Hidden from '@material-ui/core/Hidden';

import { useEffect } from 'react';

import clsx from 'clsx';

import iconSet from "../../icons/selection.json";
import IcomoonReact, { iconList } from "icomoon-react";




const Appbar = () => {

    const [open, setopen] = React.useState({
        mobile: false
    });
   

    window.onscroll = function () {
        stickAppbar()

    };

   

    let lastScroll = 0;

    
    function stickAppbar() {
        // if (window.pageYOffset > document.getElementsByClassName("about")[0].offsetTop) {
        //      //document.getElementsByClassName("appbar")[0].classList.add("sticky");
        //      //document.getElementsByClassName("appbar")[1].classList.add("sticky");


        //     window.addEventListener("scroll", () => {
        //         const currentScroll = window.pageYOffset;
        //         if (currentScroll == 0) {
        //             document.getElementsByClassName("appbar")[0].classList.remove("sticky");
        //             document.getElementsByClassName("appbar")[1].classList.remove("sticky");
        //             return;
        //         }

        //         if (currentScroll > lastScroll ) {
        //             // down
        //             console.log("down")
        //             document.getElementsByClassName("appbar")[0].classList.remove("sticky");
        //             document.getElementsByClassName("appbar")[1].classList.remove("sticky");

        //         } else if (currentScroll < lastScroll) {

        //             // up
        //                 if(window.pageYOffset > document.getElementsByClassName("about")[0].offsetTop){
        //                     document.getElementsByClassName("appbar")[0].classList.add("sticky");
        //                     document.getElementsByClassName("appbar")[1].classList.add("sticky");
        //                     }
        //                 else{
        //                     document.getElementsByClassName("appbar")[0].classList.remove("sticky");
        //                     document.getElementsByClassName("appbar")[1].classList.remove("sticky");

        //                 }
                        
                    

        //         }
        //         lastScroll = currentScroll;
        //     });




        // } else {
        //    // document.getElementsByClassName("appbar")[0].classList.remove("sticky");
        //    // document.getElementsByClassName("appbar")[1].classList.remove("sticky");

        // }

    }



    const handleDrawerToggle = () => {
        setopen(prevState => ({
            ...prevState,
            mobile: !prevState.mobile,

        }
        ));


    }



    return (


        <div>
            <Hidden smUp implementation="css">
                <input type="checkbox" className="appbar__checkbox" id="checkbox" checked={open.mobile} onChange={handleDrawerToggle} />
                <label htmlFor="checkbox" className="appbar__label" >
                    <span className="appbar__icon">&nbsp;</span>
                </label>

                <div
                    className="appbar"

                >

                    <IcomoonReact iconSet={iconSet} color="#FFF" style={{ height: "4rem", width: "4rem", margin: "0 auto" }} icon="winking-face" />


                    <Drawer

                        handleDrawerToggle={handleDrawerToggle}
                        mobileOpen={open.mobile}


                    />
                </div>

            </Hidden>






            <Hidden xsDown implementation="css">
                <div
                    className="appbar"


                >


                    <IcomoonReact iconSet={iconSet} color="#FFF" style={{ height: "4rem", width: "4rem", marginLeft: "1rem" }} icon="winking-face" />



                    <nav className="appbar__nav">
                        <ul className="appbar__list">

                            <NavLink linkTo = "home" href="">Home</NavLink>
                            <NavLink linkTo = "about" href="">About</NavLink>
                            <NavLink linkTo = "service" href="">Skills</NavLink>
                            <NavLink linkTo = "resume" href="">Resume</NavLink>

                            <NavLink linkTo = "project" href="">Projects</NavLink>
                            <NavLink linkTo = "contact" href="">Contact</NavLink>



                        </ul>
                    </nav>
                </div>

            </Hidden>
        </div>




    )

}

export default Appbar;